import { render } from "./TestData.vue?vue&type=template&id=79479653"
import script from "./TestData.vue?vue&type=script&lang=js"
export * from "./TestData.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__